import { render } from "./DatabaseSync.vue?vue&type=template&id=13c1a29e&scoped=true"
import script from "./DatabaseSync.vue?vue&type=script&lang=js"
export * from "./DatabaseSync.vue?vue&type=script&lang=js"

import "./DatabaseSync.vue?vue&type=style&index=0&id=13c1a29e&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c1a29e"]])

export default __exports__